"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../..");
var Table_1 = require("../../../Table");
var utils_1 = require("../Pomucky/utils");
var PojisteniPopup_1 = __importDefault(require("./PojisteniPopup"));
var Utils_1 = require("./Utils");
var ColoredStav = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var color = _a.color;
    return color && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), color);
});
var InformativniDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: #f7f9fa;\n  padding: 9px 16px;\n  margin: 1rem 3rem 3rem 3rem;\n"], ["\n  background-color: #f7f9fa;\n  padding: 9px 16px;\n  margin: 1rem 3rem 3rem 3rem;\n"])));
var ButtonWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: -1em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: -1em;\n  display: flex;\n  justify-content: center;\n"])));
var getStav = function (stav) {
    return react_1.default.createElement(ColoredStav, { color: Utils_1.getStavColor(stav.id) }, stav.nazev);
};
var getFirstDokument = function (doklad) {
    return doklad.dokumenty[0];
};
var PojisteniTable = function (_a) {
    var _b;
    var doklady = _a.doklady, handleOpravu = _a.handleOpravu, handleLoadMore = _a.handleLoadMore, page = _a.page, idDoklad = _a.idDoklad, idZnalce = _a.idZnalce, isNahratDisabled = _a.isNahratDisabled;
    var history = react_router_1.useHistory();
    var _c = react_1.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = react_1.useState(), dokladDetail = _d[0], setDokladDetail = _d[1];
    var handleDetail = function (item) {
        setIsOpen(true);
        setDokladDetail(item);
    };
    react_1.useEffect(function () {
        var _a;
        if (idDoklad)
            handleDetail((_a = doklady === null || doklady === void 0 ? void 0 : doklady.zaznamy) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === idDoklad; }));
    }, [doklady === null || doklady === void 0 ? void 0 : doklady.zaznamy, idDoklad]);
    var handleClose = function (open) {
        if (idDoklad)
            history.push(history.location.pathname);
        setIsOpen(open);
    };
    return !(doklady === null || doklady === void 0 ? void 0 : doklady.zaznamy) || !((_b = doklady === null || doklady === void 0 ? void 0 : doklady.zaznamy) === null || _b === void 0 ? void 0 : _b.length) ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(utils_1.StyledTable, { isDetail: true },
            react_1.default.createElement(Table_1.Table, { size: "default", keyColumn: "id", data: doklady.zaznamy, columns: [
                    {
                        title: 'Druh pojištění',
                        dataIndex: 'druh',
                        render: function (_, item) { return react_1.default.createElement("span", null, item.druhyDokladu.map(function (d) { return d.nazev; }).join(', ')); },
                    },
                    {
                        title: 'Nahráno',
                        dataIndex: 'vytvoreno',
                        render: function (_, item) { return react_1.default.createElement("span", null, __1.formatDate(item.datumVytvoreni)); },
                    },
                    {
                        title: 'Stav',
                        dataIndex: 'stav',
                        render: function (_, item) { return getStav(getFirstDokument(item).stav); },
                    },
                    {
                        dataIndex: 'detail',
                        render: function (_, item) { return (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(__1.LinkButton, { onClick: function () { return handleDetail(item); } }, "Detail"))); },
                    },
                ] })),
        (doklady.strankovani.stranekCelkem || 0) > page && (react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(__1.LinkButton, { onClick: handleLoadMore, name: "NactiDalsi" }, "Zobrazit v\u00EDce"))),
        react_1.default.createElement(PojisteniPopup_1.default, { open: isOpen, setIsOpen: handleClose, item: dokladDetail, idZnalce: idZnalce, handleOpravu: handleOpravu, isNahratDisabled: isNahratDisabled })));
};
PojisteniTable.defaultProps = {
    idDoklad: undefined,
};
exports.default = PojisteniTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
